import _ from 'lodash/fp.js';
import { fertilizers } from './params.mjs';

export function generateAvailabilityReport(data)
{
  const getSoilDensity = depth => data?.density?.[depth] || 0;

  const soilMassesTn = {
    '0-20': getSoilDensity('0-20') * 10000 * 0.2,
    '20-40': getSoilDensity('20-40') * 10000 * 0.2
  };


  const elementAtDepth = (elem, depth) => {
    const rawValue = data?.[elem]?.[depth];
    return rawValue ?? 0;
  };

  function getNitrification(data)
  {
    return (data?.nitrification) / 100;
  }

  function getMineralization(data)
  {
    return (data?.mineralization) / 100;
  }

  const calculateElementAtDepth = (elem, depth) =>
    elementAtDepth(elem, depth) * soilMassesTn?.[depth];

  const sumOfAny = (...args) => { // Devuelve la suma de los valores que no son NaN, o NaN si no hay ninguno.
    const nonNaNs = _.filter(_.negate(_.isNaN), args);
    if (_.isEmpty(nonNaNs)) return NaN;
    return _.sum(nonNaNs);
  };

  // Calculo de N

  var N_Mineralized_020, N_Mineralized_2040, NO3_020, NO3_2040;

  if(elementAtDepth('pH','0-20')>6 && elementAtDepth('pH','0-20')<=8){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2);
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62);
  }

  if(elementAtDepth('pH','20-40')>6 && elementAtDepth('pH','20-40')<=8){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2);
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62);
  }

  if((elementAtDepth('pH','0-20')>5.9 && elementAtDepth('pH','0-20')<=6) || (elementAtDepth('pH','0-20')>8 && elementAtDepth('pH','0-20')<=8.1)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.95;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.95;
  }

  if((elementAtDepth('pH','20-40')>5.9 && elementAtDepth('pH','20-40')<=6) || (elementAtDepth('pH','20-40')>8 && elementAtDepth('pH','20-40')<=8.1)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.95;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.95;
  }

  if((elementAtDepth('pH','0-20')>5.8 && elementAtDepth('pH','0-20')<=5.9) || (elementAtDepth('pH','0-20')>8.1 && elementAtDepth('pH','0-20')<=8.2)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.9;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.9;
  }

  if((elementAtDepth('pH','20-40')>5.8 && elementAtDepth('pH','20-40')<=5.9) || (elementAtDepth('pH','20-40')>8.1 && elementAtDepth('pH','20-40')<=8.2)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.9;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.9;
  }

  if((elementAtDepth('pH','0-20')>5.7 && elementAtDepth('pH','0-20')<=5.8) || (elementAtDepth('pH','0-20')>8.2 && elementAtDepth('pH','0-20')<=8.3)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.85;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.85;
  }

  if((elementAtDepth('pH','20-40')>5.7 && elementAtDepth('pH','20-40')<=5.8) || (elementAtDepth('pH','20-40')>8.2 && elementAtDepth('pH','20-40')<=8.3)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.85;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.85;
  }

  if((elementAtDepth('pH','0-20')>5.6 && elementAtDepth('pH','0-20')<=5.7) || (elementAtDepth('pH','0-20')>8.3 && elementAtDepth('pH','0-20')<=8.4)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.8;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.8;
  }

  if((elementAtDepth('pH','20-40')>5.6 && elementAtDepth('pH','20-40')<=5.7) || (elementAtDepth('pH','20-40')>8.3 && elementAtDepth('pH','20-40')<=8.4)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.8;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.8;
  }

  if((elementAtDepth('pH','0-20')>5.5 && elementAtDepth('pH','0-20')<=5.6) || (elementAtDepth('pH','0-20')>8.4 && elementAtDepth('pH','0-20')<=8.5)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.75;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.75;
  }

  if((elementAtDepth('pH','20-40')>5.5 && elementAtDepth('pH','20-40')<=5.6) || (elementAtDepth('pH','20-40')>8.4 && elementAtDepth('pH','20-40')<=8.5)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.75;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.75;
  }

  if((elementAtDepth('pH','0-20')>5.4 && elementAtDepth('pH','0-20')<=5.5) || (elementAtDepth('pH','0-20')>8.5 && elementAtDepth('pH','0-20')<=8.6)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.65;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.65;
  }

  if((elementAtDepth('pH','20-40')>5.4 && elementAtDepth('pH','20-40')<=5.5) || (elementAtDepth('pH','20-40')>8.5 && elementAtDepth('pH','20-40')<=8.6)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.65;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.65;
  }

  if((elementAtDepth('pH','0-20')>5.3 && elementAtDepth('pH','0-20')<=5.4) || (elementAtDepth('pH','0-20')>8.6 && elementAtDepth('pH','0-20')<=8.7)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.55;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.55;
  }

  if((elementAtDepth('pH','20-40')>5.3 && elementAtDepth('pH','20-40')<=5.4) || (elementAtDepth('pH','20-40')>8.6 && elementAtDepth('pH','20-40')<=8.7)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.55;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.55;
  }

  if((elementAtDepth('pH','0-20')>5.2 && elementAtDepth('pH','0-20')<=5.3) || (elementAtDepth('pH','0-20')>8.7 && elementAtDepth('pH','0-20')<=8.8)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.45;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.45;
  }

  if((elementAtDepth('pH','20-40')>5.2 && elementAtDepth('pH','20-40')<=5.3) || (elementAtDepth('pH','20-40')>8.7 && elementAtDepth('pH','20-40')<=8.8)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.45;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.45;
  }

  if((elementAtDepth('pH','0-20')>5.1 && elementAtDepth('pH','0-20')<=5.2) || (elementAtDepth('pH','0-20')>8.8 && elementAtDepth('pH','0-20')<=8.9)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.35;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.35;
  }

  if((elementAtDepth('pH','20-40')>5.1 && elementAtDepth('pH','20-40')<=5.2) || (elementAtDepth('pH','20-40')>8.8 && elementAtDepth('pH','20-40')<=8.9)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.35;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.35;
  }

  if((elementAtDepth('pH','0-20')>5 && elementAtDepth('pH','0-20')<=5.1) || (elementAtDepth('pH','0-20')>8.9 && elementAtDepth('pH','0-20')<=9)){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.25;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.25;
  }

  if((elementAtDepth('pH','20-40')>5 && elementAtDepth('pH','20-40')<=5.1) || (elementAtDepth('pH','20-40')>8.9 && elementAtDepth('pH','20-40')<=9)){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.25;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.25;
  }

  if(elementAtDepth('pH','0-20')>9 || elementAtDepth('pH','0-20')<=5){
    N_Mineralized_020 = ((calculateElementAtDepth('MO', '0-20') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.15;
    NO3_020 = ((calculateElementAtDepth('NO3','0-20') / 1000) * 14 / 62) * 0.15;
  }

  if(elementAtDepth('pH','20-40')>9 || elementAtDepth('pH','20-40')<=5){
    N_Mineralized_2040 = ((calculateElementAtDepth('MO','20-40') * getNitrification(data) * getMineralization(data) * 10)/ 2) * 0.15;
    NO3_2040 = ((calculateElementAtDepth('NO3','20-40') / 1000) * 14 / 62) * 0.15;
  }

  const N_Mineralized = N_Mineralized_020 + N_Mineralized_2040;
  const NO3 = NO3_020 + NO3_2040;

  // Calculo de P

  var P_020, P_2040;

  if(elementAtDepth('pH','0-20')>6.2 && elementAtDepth('pH','0-20')<=7.5){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000;
  }

  if(elementAtDepth('pH','20-40')>6.2 && elementAtDepth('pH','20-40')<=7.5){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000;
  }

  if((elementAtDepth('pH','0-20')>6 && elementAtDepth('pH','0-20')<=6.2) || (elementAtDepth('pH','0-20')>7.5 && elementAtDepth('pH','0-20')<=7.7)){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.9;
  }

  if((elementAtDepth('pH','20-40')>6 && elementAtDepth('pH','20-40')<=6.2) || (elementAtDepth('pH','20-40')>7.5 && elementAtDepth('pH','20-40')<=7.7)){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.9;
  }

  if((elementAtDepth('pH','0-20')>5.9 && elementAtDepth('pH','0-20')<=6) || (elementAtDepth('pH','0-20')>7.7 && elementAtDepth('pH','0-20')<=7.9)){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.85;
  }

  if((elementAtDepth('pH','20-40')>5.9 && elementAtDepth('pH','20-40')<=6) || (elementAtDepth('pH','20-40')>7.7 && elementAtDepth('pH','20-40')<=7.9)){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.85;
  }

  if((elementAtDepth('pH','0-20')>5.8 && elementAtDepth('pH','0-20')<=5.9) || (elementAtDepth('pH','0-20')>7.9 && elementAtDepth('pH','0-20')<=8.1)){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.8;
  }

  if((elementAtDepth('pH','20-40')>5.8 && elementAtDepth('pH','20-40')<=5.9) || (elementAtDepth('pH','20-40')>7.9 && elementAtDepth('pH','20-40')<=8.1)){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.8;
  }

  if((elementAtDepth('pH','0-20')>5.7 && elementAtDepth('pH','0-20')<=5.8)){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.75;
  }

  if((elementAtDepth('pH','20-40')>5.7 && elementAtDepth('pH','20-40')<=5.8)){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.75;
  }

  if(elementAtDepth('pH','0-20')>8.1 && elementAtDepth('pH','0-20')<=8.3){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.7;
  }

  if(elementAtDepth('pH','20-40')>8.1 && elementAtDepth('pH','20-40')<=8.3){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.7;
  }

  if((elementAtDepth('pH','0-20')>5.6 && elementAtDepth('pH','0-20')<=5.7) || (elementAtDepth('pH','0-20')>8.3 && elementAtDepth('pH','0-20')<=8.5)){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.6;
  }

  if((elementAtDepth('pH','20-40')>5.6 && elementAtDepth('pH','20-40')<=5.7) || (elementAtDepth('pH','20-40')>8.3 && elementAtDepth('pH','20-40')<=8.5)){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.6;
  }

  if(elementAtDepth('pH','0-20')>5.5 && elementAtDepth('pH','0-20')<=5.6){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.4;
  }

  if(elementAtDepth('pH','20-40')>5.5 && elementAtDepth('pH','20-40')<=5.6){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.4;
  }

  if((elementAtDepth('pH','0-20')<=5.5) || (elementAtDepth('pH','0-20')>8.5)){
    P_020 = (calculateElementAtDepth('P', '0-20')) / 1000 * 0.15;
  }

  if((elementAtDepth('pH','20-40')<=5.5) || (elementAtDepth('pH','20-40')>8.5)){
    P_2040 = calculateElementAtDepth('P', '20-40') / 1000 * 0.15;
  }


  // Calculo de S, K y Ca

  var S_020, S_2040, K_020, Ca_020;

  if(elementAtDepth('pH','0-20')>6 && elementAtDepth('pH','0-20')<=8){
    S_020 = (calculateElementAtDepth('S', '0-20')) / 1000;
    K_020 = (calculateElementAtDepth('K', '0-20')) / 1000;
    Ca_020 = (calculateElementAtDepth('Ca', '0-20')) / 1000;
  }

  if(elementAtDepth('pH','20-40')>6 && elementAtDepth('pH','20-40')<=8){
    S_2040 = (calculateElementAtDepth('S', '20-40')) / 1000;
  }

  if(elementAtDepth('pH','0-20')>8){
    S_020 = (calculateElementAtDepth('S', '0-20')) / 1000 * 0.9;
    K_020 = (calculateElementAtDepth('K', '0-20')) / 1000 * 0.6;
    Ca_020 = (calculateElementAtDepth('Ca', '0-20')) / 1000 * 0.5;
  }

  if(elementAtDepth('pH','20-40')>8){
    S_2040 = (calculateElementAtDepth('S', '20-40')) / 1000 * 0.9;
  }

  if(elementAtDepth('pH','0-20')>5.75 && elementAtDepth('pH','0-20')<=6){
    S_020 = (calculateElementAtDepth('S', '0-20')) / 1000 * 0.8;
    K_020 = (calculateElementAtDepth('K', '0-20')) / 1000 * 0.8;
    Ca_020 = (calculateElementAtDepth('Ca', '0-20')) / 1000 * 0.9;
  }

  if(elementAtDepth('pH','0-20')>5.5 && elementAtDepth('pH','0-20')<=5.75){
    S_020 = (calculateElementAtDepth('S', '0-20')) / 1000 * 0.8;
    K_020 = (calculateElementAtDepth('K', '0-20')) / 1000 * 0.8;
    Ca_020 = (calculateElementAtDepth('Ca', '0-20')) / 1000 * 0.8;
  }

  if(elementAtDepth('pH','20-40')>5.5 && elementAtDepth('pH','20-40')<=6){
    S_2040 = (calculateElementAtDepth('S', '20-40')) / 1000 * 0.8;
  }

  if(elementAtDepth('pH','0-20')>5.2 && elementAtDepth('pH','0-20')<=5.5){
    S_020 = (calculateElementAtDepth('S', '0-20')) / 1000 * 0.5;
    K_020 = (calculateElementAtDepth('K', '0-20')) / 1000 * 0.5;
    Ca_020 = (calculateElementAtDepth('Ca', '0-20')) / 1000 * 0.5;
  }

  if(elementAtDepth('pH','20-40')>5.2 && elementAtDepth('pH','20-40')<=5.5){
    S_2040 = (calculateElementAtDepth('S', '20-40')) / 1000 * 0.5;
  }

  if(elementAtDepth('pH','0-20')<=5.2){
    S_020 = (calculateElementAtDepth('S', '0-20')) / 1000 * 0.2;
    K_020 = (calculateElementAtDepth('K', '0-20')) / 1000 * 0.3;
    Ca_020 = (calculateElementAtDepth('Ca', '0-20')) / 1000 * 0.2;
  }

  if(elementAtDepth('pH','20-40')<=5.2){
    S_2040 = (calculateElementAtDepth('S', '20-40')) / 1000 * 0.2;
  }

  // Calculo de Mg

  var Mg_020;

  if(elementAtDepth('pH','0-20')>6.2 && elementAtDepth('pH','0-20')<=8){
    Mg_020 = (calculateElementAtDepth('Mg', '0-20')) / 1000;
  }

  if((elementAtDepth('pH','0-20')>6 && elementAtDepth('pH','0-20')<=6.2) || (elementAtDepth('pH','0-20')>8 && elementAtDepth('pH','0-20')<=8.5)){
    Mg_020 = (calculateElementAtDepth('Mg', '0-20')) / 1000 * 0.85;
  }

  if((elementAtDepth('pH','0-20')>5.75 && elementAtDepth('pH','0-20')<=6)){
    Mg_020 = (calculateElementAtDepth('Mg', '0-20')) / 1000 * 0.7;
  }

  if((elementAtDepth('pH','0-20')>5.5 && elementAtDepth('pH','0-20')<=5.75) || (elementAtDepth('pH','0-20')>8.5 && elementAtDepth('pH','0-20')<=9)){
    Mg_020 = (calculateElementAtDepth('Mg', '0-20')) / 1000 * 0.5;
  }

  if((elementAtDepth('pH','0-20')<=5.5 || elementAtDepth('pH','0-20')>9)){
    Mg_020 = (calculateElementAtDepth('Mg', '0-20')) / 1000 * 0.4;
  }

  // Muestreo

  const result = {
    N: sumOfAny(N_Mineralized, NO3),
    P: P_020 + P_2040,
    K: K_020 * 0.35,
    Mg: Mg_020 * 0.15,
    Ca: Ca_020 * 0.015,
    S: S_020 + S_2040
  };

  return result;
}

export function requirementCalculation(data){

  // Requisitos configurables por unidad de cada cultivo.
  const weights = Object.freeze({
    soja: Object.freeze({ N: 80, P: undefined, S: undefined, K: undefined, Mg: undefined, Ca: undefined }),
    trigo: Object.freeze({ N: undefined, P: undefined, S: undefined, K: undefined, Mg: undefined, Ca: undefined }),
    maiz: Object.freeze({N: undefined, P: undefined, S: undefined, K: undefined, Mg: undefined, Ca: undefined }),
    sorgo: Object.freeze({N: undefined, P: undefined, S: undefined, K: undefined, Mg: undefined, Ca: undefined }),
    girasol: Object.freeze({N: undefined, P: undefined, S: undefined, K: undefined, Mg: undefined, Ca: undefined })
  });

  // Requisitos de extracción por unidad y unidades previstas.
  let requirements = {...weights[data?.selected_crop]};
  const perf = data?.target_performance;
  const elementAtDepth = (elem, depth) => data?.[elem]?.[depth];

  // Añadir requisitos más complejos según cultivo.
  switch (data?.selected_crop) {
  case 'soja':{
    if ((elementAtDepth('P','0-20')||elementAtDepth('P','20-40'))>=20) requirements.P = 6.16;
    else requirements.P = 7;

    if ((elementAtDepth('S','0-20')||elementAtDepth('S','20-40'))>=10) requirements.S = 3.24;
    else requirements.S = 4.5;

    if ((elementAtDepth('K','0-20')||elementAtDepth('K','20-40'))>=250) requirements.K = 19.11;
    else requirements.K = 39;

    if ((elementAtDepth('Mg','0-20')||elementAtDepth('Mg','20-40'))>=100) requirements.Mg = 3.51;
    else requirements.Mg = 9;

    if ((elementAtDepth('Ca','0-20')||elementAtDepth('Ca','20-40'))>=800) requirements.Ca = 3.04;
    else requirements.Ca = 16;

    break;
  }

  case 'trigo': {
    if (perf < 3.5) requirements.N = 27;
    else if (perf >= 3.5 && perf < 5) requirements.N = 30 ;
    else if(perf >= 5 && perf < 6) requirements.N = 35;
    else if(perf >= 6 && perf < 7) requirements.N = 40;
    else requirements.N = 50;

    if (perf <= 3) requirements.P = 4.5;
    else if (perf >= 3.1 && perf <= 4) requirements.P = 5;
    else if(perf >= 4.1 && perf <= 5) requirements.P = 5.5;
    else if(perf >= 5.1 && perf <= 6) requirements.P = 6;
    else if(perf >= 6.1 && perf <= 7) requirements.P = 6.5;
    else requirements.P = 7;

    if ((elementAtDepth('S','0-20')||elementAtDepth('S','20-40'))>=10) requirements.S = 1.7;
    else requirements.S = 5;

    if ((elementAtDepth('K','0-20')||elementAtDepth('K','20-40'))>=250) requirements.K = 3.99;
    else requirements.K = 19;

    if ((elementAtDepth('Mg','0-20')||elementAtDepth('Mg','20-40'))>=100) requirements.Mg = 2.52;
    else requirements.Mg = 4;

    if ((elementAtDepth('Ca','0-20')||elementAtDepth('Ca','20-40'))>=800) requirements.Ca = 0.42;
    else requirements.Ca = 3;

    break;
  }

  case 'maiz': {
    if (perf <= 6) requirements.N = 14;
    else if (perf > 6 && perf < 9) requirements.N = 18;
    else if(perf >= 9 && perf < 11) requirements.N = 20;
    else if(perf >= 11 && perf < 15) requirements.N = 22;
    else requirements.N = 24;

    if ((elementAtDepth('P','0-20')||elementAtDepth('P','20-40'))>=20) requirements.P = 3.04; //Requerimientos * IC
    else requirements.P = 4; //Requerimientos

    if ((elementAtDepth('S','0-20')||elementAtDepth('S','20-40'))>=11) requirements.S = 1.8;
    else requirements.S = 4;

    if ((elementAtDepth('K','0-20')||elementAtDepth('K','20-40'))>=250) requirements.K = 3.99;
    else requirements.K = 19;

    if ((elementAtDepth('Mg','0-20')||elementAtDepth('Mg','20-40'))>=100) requirements.Mg = 1.59;
    else requirements.Mg = 3;

    if ((elementAtDepth('Ca','0-20')||elementAtDepth('Ca','20-40'))>=800) requirements.Ca = 0.21;
    else requirements.Ca = 3;

    break;
  }

  case 'sorgo': {
    if (perf < 3) requirements.N = 27;
    else if (perf >= 3 && perf < 5) requirements.N = 30;
    else requirements.N = 35;

    if ((elementAtDepth('P','0-20')||elementAtDepth('P','20-40'))>=20) requirements.P = 3.608;
    else requirements.P = 4.4;

    if ((elementAtDepth('S','0-20')||elementAtDepth('S','20-40'))>=10) requirements.S = 2.1375;
    else requirements.S = 3.75;

    if ((elementAtDepth('K','0-20')||elementAtDepth('K','20-40'))>=250) requirements.K = 3.952;
    else requirements.K = 20.8;

    if ((elementAtDepth('Mg','0-20')||elementAtDepth('Mg','20-40'))>=100) requirements.Mg = 1.305;
    else requirements.Mg = 4.5;

    if ((elementAtDepth('Ca','0-20')||elementAtDepth('Ca','20-40'))>=800) requirements.Ca = 0.4;
    else requirements.Ca = 4;

    break;
  }

  case 'girasol': {
    if (perf < 2) requirements.N = 35;
    else if (perf >= 2 && perf < 3) requirements.N = 40 ;
    else if(perf >= 3 && perf < 4) requirements.N = 45;
    else requirements.N = 50;

    if ((elementAtDepth('P','0-20')||elementAtDepth('P','20-40'))>=20) requirements.P = 6.82;
    else requirements.P = 11;

    if ((elementAtDepth('S','0-20')||elementAtDepth('S','20-40'))>=10) requirements.S = 2.25;
    else requirements.S = 5;

    if ((elementAtDepth('K','0-20')||elementAtDepth('K','20-40'))>=250) requirements.K = 5.51;
    else requirements.K = 29;

    if ((elementAtDepth('Mg','0-20')||elementAtDepth('Mg','20-40'))>=100) requirements.Mg = 3.08;
    else requirements.Mg = 11;

    if ((elementAtDepth('Ca','0-20')||elementAtDepth('Ca','20-40'))>=800) requirements.Ca = 1.44;
    else requirements.Ca = 18;

    break;
  }

  default:
    break;
  }

  if ([ 'trigo', 'soja', 'maiz', 'sorgo', 'girasol' ].includes(data?.selected_crop))
    requirements = _.mapValues((value) => value * perf)(requirements);

  return requirements;
}

export const elementRatioByFertilizer = Object.freeze({
  urea: Object.freeze({ N: 0.46, P: 0, K: 0, S: 0, Ca: 0, Mg: 0 }),
  nitratoNh4: Object.freeze({ N: 0.33, P: 0, K: 0, S: 0, Ca: 0, Mg: 0 }),
  nacs: Object.freeze({ N: 0.24, P: 0, K: 0, S: 0.06, Ca: 0.06, Mg: 0.04 }),
  aa: Object.freeze({ N: 0.87, P: 0, K: 0, S: 0, Ca: 0, Mg: 0 }),
  uan: Object.freeze({ N: 0.32, P: 0, K: 0, S: 0, Ca: 0, Mg: 0 }),
  solMix: Object.freeze({ N: 0.32, P: 0, K: 0, S: 0.03, Ca: 0, Mg: 0 }),
  map: Object.freeze({ N: 0.11, P: 0.52, K: 0, S: 0, Ca: 0, Mg: 0 }),
  dap: Object.freeze({ N: 0.18, P: 0.46, K: 0, S: 0, Ca: 0, Mg: 0 }),
  nitratoK: Object.freeze({ N: 0.13, P: 0, K: 0.44, S: 0, Ca: 0, Mg: 0 }),
  sulfatoNh4: Object.freeze({ N: 0.21, P: 0, K: 0, S: 0.24, Ca: 0, Mg: 0 }),
  sulfonitrato: Object.freeze({ N: 0.26, P: 0, K: 0, S: 0.14, Ca: 0, Mg: 0 }),
  sulfan: Object.freeze({ N: 0.24, P: 0, K: 0, S: 0.06, Ca: 0.11, Mg: 0 }),
  sps: Object.freeze({ N: 0, P: 0.20, K: 0, S: 0.12, Ca: 0.20, Mg: 0 }),
  spt: Object.freeze({ N: 0, P: 0.46, K: 0, S: 0.14, Ca: 0, Mg: 0 }),
  no3k: Object.freeze({ N: 0, P: 0, K: 0.45, S: 0, Ca: 0, Mg: 0 }),
  clk: Object.freeze({ N: 0, P: 0, K: 0.60, S: 0, Ca: 0, Mg: 0 }),
  sulfatoK: Object.freeze({ N: 0, P: 0, K: 0.50, S: 0.18, Ca: 0, Mg: 0 }),
  canS: Object.freeze({ N: 0.24, P: 0, K: 0, S: 0.06, Ca: 0.11, Mg: 0 }),
  sMg: Object.freeze({ N: 0, P: 0, K: 0, S: 0.18, Ca: 0, Mg: 0.22 }),
  nitroDoble: Object.freeze({ N: 0.27, P: 0, K: 0, S: 0, Ca: 0.06, Mg: 0.04 }),
  nitrocomplex: Object.freeze({ N: 0.21, P: 0.17, K: 0.03, S: 0.04, Ca: 0, Mg: 0.01 }),
  hydrocomplex: Object.freeze({ N: 0.12, P: 0.11, K: 0.18, S: 0.08, Ca: 0.04, Mg: 0.03 }),
  microEssentialsSZ: Object.freeze({ N: 0.12, P: 0.40, K: 0, S: 0.10, Ca: 0, Mg: 0 }),
  microEssentialsS9: Object.freeze({ N: 0.10, P: 0.46, K: 0, S: 0.09, Ca: 0, Mg: 0 }),
  topika: Object.freeze({ N: 0.13, P: 0, K: 0.46, S: 0, Ca: 0, Mg: 0 }),
  sausor: Object.freeze({ N: 0.03, P: 0.30, K: 0, S: 0.06, Ca: 0.22, Mg: 0 }),
  rega: Object.freeze({ N: 0.20, P: 0.05, K: 0.17, S: 0, Ca: 0, Mg: 0.02 }),
  microstar: Object.freeze({ N: 0.10, P: 0.40, K: 0, S: 0.10, Ca: 0, Mg: 0 }),
  basifertilPlus: Object.freeze({ N: 0.03, P: 0.18, K: 0, S: 0.10, Ca: 0.14, Mg: 0.02 }),
  basifertilAzote: Object.freeze({ N: 0.20, P: 0.10, K: 0, S: 0.07, Ca: 0.05, Mg: 0 }),
  basifertilKent: Object.freeze({ N: 0.05, P: 0.12, K: 0.08, S: 0.09, Ca: 0.12, Mg: 0 }),
  sulfano22: Object.freeze({ N: 0.22, P: 0, K: 0, S: 0.05, Ca: 0.10, Mg: 0.02 }),
  sulfano29: Object.freeze({ N: 0.29, P: 0, K: 0, S: 0.07, Ca: 0.05, Mg: 0.02 }),
  topPhos118: Object.freeze({ N: 0, P: 0.18, K: 0, S: 0.11, Ca: 0.18, Mg: 0 }),
  topPhos280: Object.freeze({ N: 0.01, P: 0.28, K: 0, S: 0.05, Ca: 0.17, Mg: 0 }),
  mezclaQuimica: Object.freeze({ N: 0.12, P: 0.40, K: 0, S: 0.05, Ca: 0, Mg: 0 }),
});

export const fertilizerEfficiency = Object.freeze({
  urea: 0.9,
  nitratoNh4: 0.9,
  nacs: 0.85,
  aa: 0.85,
  uan: 0.75,
  solMix: 0.8,
  map: 0.85,
  dap: 0.85,
  nitratoK: 0.9,
  sulfatoNh4: 0.85,
  sulfonitrato: 0.85,
  sulfan: 0.85,
  sps: 0.8,
  spt: 0.85,
  no3k: 0.9,
  clk: 0.9,
  sulfatoK: 0.95,
  canS: 0.9,
  sMg: 0.9,
  nitroDoble: 0.9,
  nitrocomplex: 0.9,
  hydrocomplex: 0.9,
  microEssentialsSZ: 0.95,
  microEssentialsS9: 0.95,
  topika: 0.9,
  sausor: 0.9,
  rega: 0.9,
  microstar: 0.95,
  basifertilPlus: 0.9,
  basifertilAzote: 0.9,
  basifertilKent: 0.9,
  sulfano22: 0.9,
  sulfano29: 0.9,
  topPhos118: 0.9,
  topPhos280: 0.9,
  mezclaQuimica: 0.8
});

export const fertilizerPrices = Object.freeze({
  urea: 0.430,
  nitratoNh4: 0.420,
  nacs: 0.470,
  aa: 0.500,
  uan: 0.420,
  solMix: 0.440,
  map: 0.556,
  dap: 0.510,
  nitratoK: 0.650,
  sulfatoNh4: 0.350,
  sulfonitrato: 0.480,
  sulfan: 0.500,
  sps: 0.252,
  spt: 0.455,
  no3k: 0.650,
  clk: 0.560,
  sulfatoK: 0.450,
  canS: 0.400,
  sMg: 0.350,
  nitroDoble: 0.310,
  nitrocomplex: 0.488,
  hydrocomplex: 0.500,
  microEssentialsSZ: 0.520,
  microEssentialsS9: 0.510,
  topika: 0.490,
  sausor: 0.460,
  rega: 0.440,
  microstar: 0.480,
  basifertilPlus: 0.460,
  basifertilAzote: 0.470,
  basifertilKent: 0.465,
  sulfano22: 0.450,
  sulfano29: 0.470,
  topPhos118: 0.460,
  topPhos280: 0.470,
  mezclaQuimica: 0.400
});

export function fertilizerCalculation(data){

  const results = [];

  for (const fertilizer in fertilizers) {
    const kgUsed = data?.[fertilizer]?.kgUsed ?? 0;
    const result = _.mapValues((ratio) => ratio * kgUsed * fertilizerEfficiency[fertilizer])(elementRatioByFertilizer[fertilizer]);
    results.push(result);
  }

  const sum = _.reduce((acc, curr) => {
    const res = {};
    for (const key in curr) {
      res[key] = (acc[key] ?? 0) + curr[key];
    }
    return res;
  }, {}, results);

  return sum;
}

// Detectar nutrientes deficitarios.
export function getDeficientNutrients(balance) {
  return Object.entries(balance)
    .filter(([_, value]) => value < 0)
    .map(([nutrient]) => nutrient);
}

// Recomendar fertilizantes según nutrientes faltantes.
export function recommendFertilizers(deficientNutrients) {
  const recommendations = [];

  for (const [fertilizer, composition] of Object.entries(elementRatioByFertilizer)) {
    const covers = deficientNutrients.filter(nutrient => composition[nutrient] > 0);
    if (covers.length > 0) {
      recommendations.push({
        fertilizer,
        covers,
        composition,
        efficiency: fertilizerEfficiency[fertilizer]
      });
    }
  }

  return recommendations;
}

// Calcular dosis necesaria para cubrir el déficit.
export function calculateFertilizerDose(deficit, fertilizer, nutrient) {
  const composition = elementRatioByFertilizer[fertilizer][nutrient];
  const efficiency = fertilizerEfficiency[fertilizer];

  if (composition === 0 || !composition) return 0;
  return Math.ceil(deficit / (composition * efficiency)); // kg/ha redondeado hacia arriba.
}

// Calcular aporte total si se eligen fertilizantes.
export function calculateFertilizerContribution(selectedFertilizers, balance) {
  const newBalance = { ...balance };
  const contribution = {};

  for (const [fertilizer, dose] of Object.entries(selectedFertilizers)) {
    for (const nutrient in elementRatioByFertilizer[fertilizer]) {
      const aportado = dose * elementRatioByFertilizer[fertilizer][nutrient] * fertilizerEfficiency[fertilizer];
      contribution[nutrient] = (contribution[nutrient] ?? 0) + aportado;
      newBalance[nutrient] = (newBalance[nutrient] ?? 0) + aportado;
    }
  }

  return { contribution, newBalance };
}

const NUTRIENT_PRIORITY = ['N','P','K','Mg','Ca','S'];

// Costo efectivo (USD por kg de nutriente aportado).
function costPerKgNutrient(fertilizerKey, nutrient) {
  const ratio = elementRatioByFertilizer[fertilizerKey]?.[nutrient] ?? 0;
  if (!ratio) return Infinity;
  const eff = fertilizerEfficiency[fertilizerKey] ?? 1;
  const priceKg = fertilizerPrices[fertilizerKey] ?? Infinity;
  // kg nutriente / kg producto = ratio * eff → USD/kg nutriente = USD/kg producto / (ratio*eff).
  return priceKg / (ratio * eff);
}

// Elegimos el producto más barato por nutriente.
function pickCheapestFertilizerFor(nutrient) {
  let best = null;
  let bestCost = Infinity;
  for (const key of Object.keys(fertilizers)) {
    const c = costPerKgNutrient(key, nutrient);
    if (c < bestCost) {
      best = key;
      bestCost = c;
    }
  }
  return best;
}

// Construye déficits positivos: si balance < 2, déficit = |balance|.
export function computeDeficits(result, requirements) {
  const deficits = {};
  const balance = {};
  for (const k of Object.keys(requirements)) {
    const disp = Number(result?.[k] ?? 0);
    const req = Number(requirements?.[k] ?? 0);
    const bal = disp - req;
    balance[k] = bal;
    if (bal < 2) deficits[k] = Math.abs(bal);
  }
  return { balance, deficits };
}

// Recomendación global: elige barato por nutriente, calcula dosis para cubrir el déficit,
// descuenta co-aportes en otros nutrientes y acumula dosis si el mismo producto aparece varias veces.
export function buildFertilizerPlan(deficitsInput) {
  const deficits = { ...deficitsInput };
  const selectionKgHa = {};
  const MAX_ITERS = 20;

  // Iteramos en prioridad de nutrientes.
  let iter = 0;
  while (Object.values(deficits).some(v => v > 1e-6) && iter < MAX_ITERS) {
    iter++;
    for (const nutrient of NUTRIENT_PRIORITY) {
      const deficit = deficits[nutrient] ?? 0;
      if (deficit <= 0) continue;

      const fert = pickCheapestFertilizerFor(nutrient);
      if (!fert) continue;

      const ratio = elementRatioByFertilizer[fert][nutrient] || 0;
      const eff = fertilizerEfficiency[fert] || 1;
      if (ratio <= 0) continue;

      // Dosis mínima para cubrir lo que falta de este nutriente + margen.
      const EXCESS_NUTRIENT_KG = 3;
      const doseKgHa = ( (deficit + EXCESS_NUTRIENT_KG) / (ratio * eff) );

      // Acumular.
      selectionKgHa[fert] = (selectionKgHa[fert] ?? 0) + doseKgHa;

      // Aplicar co-aportes de este producto y descontar en TODOS los nutrientes.
      const comp = elementRatioByFertilizer[fert];
      for (const n of Object.keys(deficits)) {
        const r = comp[n] ?? 0;
        if (r > 0) {
          const aportado = doseKgHa * r * eff; // kg/ha nutriente.
          deficits[n] = Math.max(0, (deficits[n] ?? 0) - aportado);
        }
      }
    }
  }

  return selectionKgHa;
}

// Aportes totales y costo.
export function summarizePlan(selectionKgHa) {
  const contribution = {}; // kg/ha por nutriente.
  let totalUSDha = 0;
  const items = []; // Detalle por producto.

  for (const [fert, kgHa] of Object.entries(selectionKgHa)) {
    const eff = fertilizerEfficiency[fert] ?? 1;
    const comp = elementRatioByFertilizer[fert] ?? {};
    const price = fertilizerPrices[fert] ?? 0;
    const cost = kgHa * price;
    totalUSDha += cost;

    // Aporte por nutriente.
    for (const n of Object.keys(comp)) {
      const aportado = kgHa * (comp[n] ?? 0) * eff;
      if (aportado > 0) {
        contribution[n] = (contribution[n] ?? 0) + aportado;
      }
    }

    items.push({
      fertilizerKey: fert,
      fertilizerLabel: fertilizers[fert],
      kgHa: kgHa,
      usdHa: cost
    });
  }

  return { contribution, totalUSDha, items };
}